// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"a86c35e6","239":"a9cda043","453":"ceb4b457","455":"03c9e053","490":"6025487c","977":"9e6d9943"}[chunkId] + ".chunk.js";
};